import Phaser from "phaser";

import { Colors } from "../consts/Colors";
import { tags } from "../consts/Tags";

export default class TitreJeu extends Phaser.GameObjects.Container {
  constructor(scene, x, y, text, text2, text3, maxWidth = 200, ratio = 1) {
    super(scene, x, y);

    const paddingX = 10 * ratio;
    const paddingY = 4 * ratio;

    // === TEXTE TAGUÉ ===
    const label = scene.add
      .rexTagText(paddingX, paddingY, text, {
        fontFamily: "WWF",
        fontSize: `${32 * ratio}px`,
        color: "#ffffff",
        wrap: {
          mode: "word",
          width: maxWidth - paddingX * 2,
        },
        halign: "left",
        tags: tags,
        backgroundColor: "transparent",
        lineSpacing: 2 * ratio,
        textStyle: {
          fontStyle: "bold",
          textTransform: "uppercase",
        },
      })
      .setOrigin(0);

    const bounds = label.getBounds();
    const backgroundWidth = bounds.width * 1 + paddingX * 2;
    const backgroundHeight = bounds.height + paddingY * 2;

    const bgShadow = scene.add
      .rexRoundRectangle(
        2,
        2,
        backgroundWidth,
        backgroundHeight,
        4,
        0x000000,
        0.5
      )
      .setOrigin(0);

    const bg = scene.add
      .rexRoundRectangle(
        0,
        0,
        backgroundWidth,
        backgroundHeight,
        4,
        Colors.Elmt.BleuNovotel
      )
      .setOrigin(0);

    const alignLeftX = label.x - backgroundWidth / 2 + paddingX - 16;

    const soustitre = scene.add
      .rexTagText(0, 90, text2, {
        fontFamily: "WWF",
        fontSize: `${32 * ratio}px`,
        color: Colors.Text.DarkBlue,
        wrap: {
          mode: "word",
          width: maxWidth - paddingX * 2,
        },
        halign: "left",
        tags: tags,
        backgroundColor: "transparent",
        lineSpacing: 2 * ratio,
        textStyle: {
          fontStyle: "bold",
          textTransform: "uppercase",
        },
      })
      .setOrigin(0);

    const description = scene.add
      .rexTagText(0, 160, text3, {
        fontFamily: "Binx",
        fontSize: `${16 * ratio}px`,
        color: Colors.Text.DarkBlue,
        wrap: {
          mode: "word",
          width: maxWidth - paddingX * 2,
        },
        halign: "left",
        tags: tags,
        backgroundColor: "transparent",
        lineSpacing: 2 * ratio,
        textStyle: {
          fontStyle: "bold",
          textTransform: "uppercase",
        },
      })
      .setOrigin(0);

    this.add([bgShadow, bg, label, soustitre, description]);
    scene.add.existing(this);
  }
}
